export default "__VITE_ASSET__B8tKt3ZA__"